import { useCallback, useMemo, useState } from 'react';
import type {
  HistoryPageFilter,
  OperationHistoryFilterItem,
} from '@/shared/types';

type Props = {
  operationTypes: OperationHistoryFilterItem[];
};

export const useHistoryPageFilters = ({ operationTypes }: Props) => {
  const initialFilter = operationTypes[0]?.filter ?? 'all';

  const [filters, setFilters] = useState<HistoryPageFilter>({
    filter: initialFilter,
    datefilter: undefined,
    datefrom: undefined,
    dateto: undefined,
  });

  const resetPeriod = useCallback(() => {
    setFilters(prev => ({
      ...prev,
      datefilter: undefined,
      datefrom: undefined,
      dateto: undefined,
    }));
  }, [setFilters]);

  const isPeriodApplied = useMemo(() => {
    return (
      Boolean(filters.datefilter) ||
      (Boolean(filters.datefrom) && Boolean(filters.dateto))
    );
  }, [filters]);

  return {
    filters,
    setPageFilters: setFilters,
    resetPeriod,
    isPeriodApplied,
  };
};
